import React, { useState, useEffect } from "react";
import moment from "moment";

var callActive;
var photo;
var nameCol;
var colorHold;
var color;
var callTimers = {};
var colorIconMute;
var colorMute;
var Stopwatch = function (elem, options) {
  // private functions
  function createTimer() {
    return document.createElement("span");
  }

  var timer = createTimer(),
    offset,
    clock,
    interval;

  // default options
  options = options || {};
  options.delay = options.delay || 1000;
  options.startTime = options.startTime;

  // append elements
  elem.appendChild(timer);

  function start() {
    if (!interval) {
      offset = options.startTime;
      interval = setInterval(update, options.delay);
    }
  }

  function stop() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  function reset() {
    clock = 0;
    render();
  }

  function update() {
    clock += delta();
    render();
  }

  function render() {
    timer.innerHTML = moment(clock).format("mm:ss");
  }

  function delta() {
    var now = Date.now(),
      d = now - offset;

    offset = now;
    return d;
  }

  // initialize
  reset();

  // public API
  this.start = start; //function() { start; }
  this.stop = stop; //function() { stop; }
};

function CallPageDown({
  session,
  activecall,
  upBtn,
  upBtnVideo,
  hungUp,
  muteSession,
  holdSession,
  tab,
}) {
  useEffect(() => {
    if (callActive.statusAppel !== "ringing") {
      const tEle = document.getElementById("watch");
      if (tEle) {
        tEle.innerHTML = "";
        callTimers[callActive] = new Stopwatch(tEle, {
          startTime: callActive.date,
        });
        callTimers[callActive].start();
      }
    } else callTimers[callActive]?.stop();
  }, [activecall, session]);

  if (session.length > 1) {
    callActive = activecall;
  } else {
    callActive = session[0];
  }

  callActive.ismute === "yes"
    ? (colorIconMute = "text-gray-900")
    : (colorIconMute = "text-Slate-50");
  callActive.ismute === "yes"
    ? (colorMute = "white")
    : (colorMute = "rgb(255 255 255 / 25%)");

  callActive.statusAppel === "holding"
    ? (color = "text-gray-900")
    : (color = "text-Slate-50");
  callActive.statusAppel === "holding"
    ? (colorHold = "white")
    : (colorHold = "rgb(255 255 255 / 25%)");

  if (session.length > 1) {
    callActive = activecall;
  } else {
    callActive = session[0];
  }
  if (
    tab.find(
      (element) => element.poste === callActive.remoteIdentity.uri.user
    ) !== undefined &&
    tab[
      tab.indexOf(
        tab.find(
          (element) => element.poste === callActive.remoteIdentity.uri.user
        )
      )
    ].photo_poste_interne !== ""
  ) {
    photo =
      tab[
        tab.indexOf(
          tab.find(
            (element) => element.poste === callActive.remoteIdentity.uri.user
          )
        )
      ].lien_photo_poste_interne;
  } else {
    photo = null;
  }

  if (
    tab.find(
      (element) => element.poste === callActive.remoteIdentity.uri.user
    ) !== undefined
  ) {
    nameCol =
      tab[
        tab.indexOf(
          tab.find(
            (element) => element.poste === callActive.remoteIdentity.uri.user
          )
        )
      ].nom;
  } else {
    nameCol = callActive.remoteIdentity.uri.user;
  }

  if (
    callActive.direction === "incoming" &&
    callActive.statusAppel === "ringing"
  ) {
    return (
      //   <div style={{display:'flex',flexDirection:'row-reverse',height:'100%'}}>
      //   <div style={{margin:'auto 18px',width:'100%',display:'flex',justifyContent:'space-around'}}>
      //   <div style={{display:'flex'}}>
      //     <button onClick={() => upBtn(callActive)}  style={{height:'35px',width:'35px',backgroundColor:'white',borderRadius:'100%',marginRight:'7px',border:'2px  solid #ebebeb'}}><svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" style={{margin:'auto',color:'green'}}> <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" /> </svg></button>
      //     <button onClick={() => hungUp(callActive)} style={{height:'35px',width:'35px',backgroundColor:'white',borderRadius:'100%',marginRight:'7px',border:'2px  solid #ebebeb'}}><svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" style={{margin:'auto',color:'red',transform:'rotate(136deg)'}}> <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" /> </svg></button>
      //     </div>
      //     <div style={{color:'white',fontWeight:'bold',margin:'auto 0'}}>{callActive.remoteIdentity.uri.user}</div>

      //   </div>
      // </div>
      <div className="pageDown" style={{ margin: "41px 33px 0 10px" }}>
        <div>
          {photo !== null ? (
            <img
              style={{
                borderRadius: "100%",
                height: "100px",
                width: "100px",
                margin: "auto",
              }}
              src={photo}
            />
          ) : (
            <svg
              className="h-full w-full text-gray-300 dark:text-gray-400"
              fill="currentColor"
              viewBox="0 0 24 24"
              style={{
                height: "100px",
                width: "100px",
                margin: "auto",
                borderRadius: "100%",
                border: "1px solid #f2f2f2a6",
              }}
            >
              <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
            </svg>
          )}
          <div
            style={{ textAlign: "center", color: "white", fontWeight: "bold" }}
          >
            {nameCol}
          </div>
          <div
            style={{ textAlign: "center", color: "white", fontWeight: "bold" }}
          >
            {callActive.remoteIdentity.uri.user}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            id="upBtn"
            className="upBtn"
            onClick={() => upBtn(callActive)}
            style={{ marginRight: "5px" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ margin: "auto" }}
            >
              {" "}
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
            </svg>
          </button>
          {callActive.type === "video" ? (
            <button
              onClick={() => upBtnVideo(callActive)}
              id="upBtnVideo"
              className="upBtnVideo"
              style={{ marginRight: "5px" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                style={{ margin: "auto" }}
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                />{" "}
              </svg>
            </button>
          ) : null}
          <button
            id="hungup"
            className="hungup"
            onClick={() => hungUp(callActive)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
              style={{ margin: "auto", transform: "rotate( 136deg )" }}
            >
              {" "}
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
            </svg>
          </button>
        </div>
        {/* <div style={{marginRight:'9px'}}>
    <Progress type="circle" percent={75} width={30}/>
    <div style={{color:'white',fontSize:'xx-small',fontWeight:'bold'}}>appels effectués</div>
    
    </div>
    <div  style={{marginRight:'9px'}}>
    <Progress type="circle" percent={60} status="exception" width={30} />
    <div style={{color:'white',fontSize:'xx-small',fontWeight:'bold'}}>appels perdus</div>

    </div>
    <div>
    <Progress type="circle" percent={100} width={30}/>
    <div style={{color:'white',fontSize:'xx-small',fontWeight:'bold'}}>appels reçus</div>

    </div> */}
      </div>
    );
  } else {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          height: "100%",
        }}
      >
        <div
          style={{
            margin: "auto 45px",
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <div style={{ display: "flex" }}>
            <button
              onClick={() => hungUp(callActive)}
              style={{
                height: "35px",
                width: "35px",
                backgroundColor: "white",
                borderRadius: "100%",
                marginRight: "7px",
                border: "2px  solid #ebebeb",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
                style={{
                  margin: "auto",
                  color: "red",
                  transform: "rotate(136deg)",
                }}
              >
                {" "}
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />{" "}
              </svg>
            </button>
            <button
              onClick={() => muteSession(callActive)}
              style={{
                height: "35px",
                width: "35px",
                backgroundColor: "white",
                borderRadius: "100%",
                marginRight: "7px",
                border: "2px  solid #ebebeb",
                backgroundColor: colorMute,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={"h-5 w-5" + colorIconMute}
                viewBox="0 0 20 20"
                fill="currentColor"
                style={{ margin: "auto", color: "#b6b6b6" }}
              >
                {" "}
                <path
                  fillRule="evenodd"
                  d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z"
                  clipRule="evenodd"
                />{" "}
              </svg>
            </button>
            <button
              onClick={() => holdSession(callActive)}
              style={{
                height: "35px",
                width: "35px",
                backgroundColor: "white",
                borderRadius: "100%",
                border: "2px  solid #ebebeb",
                backgroundColor: colorHold,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={"h-5 w-5" + color}
                viewBox="0 0 20 20"
                fill="currentColor"
                style={{ margin: "auto", color: "#b6b6b6" }}
              >
                {" "}
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />{" "}
              </svg>
            </button>
          </div>
          <div
            id="watch"
            style={{ color: "white", fontWeight: "bold", margin: "auto 12px" }}
          ></div>
          <div style={{ color: "white", fontWeight: "bold", margin: "auto 0" }}>
            {callActive.conf !== "null"
              ? "Conférence audio " +
                callActive.remoteIdentity.uri.user +
                "--" +
                callActive.conf.remoteIdentity.uri.user
              : callActive.remoteIdentity.uri.user}
          </div>
        </div>
      </div>
    );
  }
}

export default CallPageDown;
